import React, { useEffect, useState } from 'react'
import { getStatus, subscribe, dismissDowngrade, dismissRigProblem, downgradeMessage } from '../lib/ogsAssetStatus'

const PILL = {
  position: 'absolute', right: 12, zIndex: 31,
  background: 'rgba(40,30,10,0.9)', border: '1px solid #7a5a1a',
  borderRadius: 4, padding: '6px 10px', maxWidth: 320,
  color: '#e0b45c', fontFamily: 'var(--m-font)', fontSize: 11,
  display: 'flex', alignItems: 'center', gap: 8, pointerEvents: 'auto',
}
const CLOSE = { background: 'none', border: 'none', color: '#e0b45c', cursor: 'pointer', fontSize: 14, lineHeight: 1, padding: 0 }

// One headline per cause, and the cause decides which. A pill that always said
// "upload a head.dna" sent someone who typed ?rig=orl off to produce an asset
// they already knew was missing, and told someone whose pack is the WRONG
// character's to upload the file they just uploaded.
const RIG_HEADLINE = {
  'upload-dna': 'No face rig — drop this character’s head.dna on the content browser to add one.',
  'drop-flag': 'A ?rig= flag asked for a rig this character does not have — drop the flag.',
  mismatch: 'This character’s rig does not fit its mesh — re-ingest the right head.dna.',
}

/**
 * OGSAssetWarningIndicator — viewport pill shown when the OGS pipeline auto-fell
 * back from a capability it wanted: a decoder off fp16 (no shader-f16), or the
 * lift off WebGPU onto the CPU. A capability warning, not transient progress — so it's persistent
 * and dismissible (unlike the auto-hiding TextureUpgradeIndicator). Reads the
 * ogsAssetStatus module singleton (subscription tick, no polling). Amber, offset
 * below the texture pill so the two never overlap.
 */
export default function OGSAssetWarningIndicator() {
  const [status, setStatus] = useState(getStatus())
  useEffect(() => subscribe(() => setStatus(getStatus())), [])
  const { downgrade, rigProblem } = status
  if (!downgrade && !rigProblem) return null
  return (
    <>
      {downgrade && (
        <div style={{ ...PILL, top: 44 }} data-testid="ogs-asset-warning">
          <span>{downgradeMessage(downgrade.kind)}</span>
          <button onClick={dismissDowngrade} aria-label="Dismiss" style={CLOSE}>×</button>
        </div>
      )}
      {/* Stacked below the downgrade pill so the two never overlap when both apply. */}
      {rigProblem && (
        <div style={{ ...PILL, top: downgrade ? 88 : 44 }} data-testid="ogs-missing-rig-warning">
          <span>
            {RIG_HEADLINE[rigProblem.cause] ?? RIG_HEADLINE['upload-dna']}{' '}
            The head for “{rigProblem.slug}” is showing its neutral pose and will not move.
            {/* The resolution's own words underneath the headline. The headline is
                the ACTION and varies by cause; this is the evidence. */}
            {rigProblem.detail ? <em style={{ opacity: 0.75 }}> ({rigProblem.detail})</em> : null}
          </span>
          <button onClick={dismissRigProblem} aria-label="Dismiss" style={CLOSE}>×</button>
        </div>
      )}
    </>
  )
}
